import Lottie from "lottie-react";
import compass from "../../../../assets/animations/compass.json"

const WindCompass = ({ }) => {


    return (
        <div >
            <Lottie style={{}} animationData={compass} loop={true} />
        </div>
    );
};

export default WindCompass;